export default {
  apiKey: 'AIzaSyAdRiS-lDbejHMBwDbTyiPOXMha4eLIsk8',
  authDomain: 'krdm-d1b24.firebaseapp.com',
  databaseURL: 'https://krdm-d1b24.firebaseio.com',
  projectId: 'krdm-d1b24',
  storageBucket: 'krdm-d1b24.appspot.com',
  messagingSenderId: '10320780629',
};
